/** A safe, actionable message from a feature that could not finish before sign-out. */
export class SignOutBlockedError extends Error {
  constructor(
    message: string,
    readonly workshopActivityId?: string | null,
  ) {
    super(message);
  }
}
